import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";

const NewBabyForm = (props) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const params = {
      name: formData.get("name"),
      date_of_birth: formData.get("date_of_birth"),
      diapers: formData.get("diapers"),
      formula: formData.get("formula"),
      formula_type: formData.get("formula_type"),
      formula_amount: formData.get("formula_amount"),
    };
    props.createBaby(params);
    event.currentTarget.reset()
    document.querySelector("button.accordion-button").click()
    
  };
  return (
    <>
      <Form className="form d-flex flex-column" onSubmit={handleSubmit}>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Name</u></Form.Label>
          <Form.Control htmlFor="name" id="name" name="name" type="text" />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Date of birth</u></Form.Label>
          <Form.Control
            htmlFor="date_of_birth"
            id="date_of_birth"
            name="date_of_birth"
            type="date"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Diapers</u></Form.Label>

          <Form.Control
            htmlFor="diapers"
            id="diapers"
            name="diapers"
            type="date"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Formula</u></Form.Label>

          <Form.Control
            htmlFor="formula"
            id="formula"
            name="formula"
            type="date"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Formula type</u></Form.Label>

          <Form.Control
            htmlFor="formula_type"
            id="formula_type"
            name="formula_type"
            type="text"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label><u>Formula amount</u></Form.Label>

          <Form.Control
            htmlFor="formula_amount"
            id="formula_amount"
            name="formula_amount"
            type="text"
          />
        </FormGroup>
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
    </>
  );
};

export default NewBabyForm;
